
import { createSlice } from '@reduxjs/toolkit'



const forceСreate = createSlice({
    name: 'forceСreate',
    initialState: {
        force: false,
    },
    reducers: {
        forceToggle(state, { payload }) {
            state.force = payload
        },
    },

})
export const { forceToggle } = forceСreate.actions
export default forceСreate.reducer